import { isAdminSubDomain, isOlhDomain } from '../helpers/utils.helper';

export const ACTIVE_BLUE = '#1890FF' as const;

const primary = { background: ACTIVE_BLUE, borderColor: ACTIVE_BLUE, color: '#FFFFFF' };
const neutral = { background: '#FFFFFF', borderColor: ACTIVE_BLUE, color: ACTIVE_BLUE };

export const BUTTON_STYLE = {
  primary,
  neutral,
};

export const CRITICAL_RISK_COLOR = '#106E84' as const;
export const NEUTRAL_RISK_COLOR = 'black' as const;
export const LOW_RISK_COLOR = '#337c00' as const;
export const MEDIUM_RISK_COLOR = '#ffa70d' as const;
export const HIGH_RISK_COLOR = '#a9181c' as const;
export const WARNING_COLOR = '#f3a536' as const;

export const LOGO = isAdminSubDomain
  ? { src: '/assets/trycycle-logo.png', alt: 'TryCycle Data Systems logo', sidebarHeight: 32 }
  : isOlhDomain
    ? { src: '/assets/OLH-Logo-Hoz.svg', alt: 'Ontario Legion Health logo', sidebarHeight: 38 }
    : { src: '/assets/ta-logo.png', alt: 'TetherAll logo', sidebarHeight: 40 };

export const SMALL_LOGO = isAdminSubDomain
  ? { src: '/assets/trycycle-icon.png', alt: 'TryCycle Data Systems logo', sidebarHeight: 32 }
  : isOlhDomain
    ? { src: '/assets/OLH-Icon-Red.svg', alt: 'Ontario Legion Health logo', sidebarHeight: 38 }
    : { src: '/assets/ta-icon.png', alt: 'TetherAll logo', sidebarHeight: 32 };

export const FAVICON = isAdminSubDomain
  ? '/assets/trycycle-icon.png'
  : isOlhDomain
    ? '/assets/OLH-Icon-Red.svg'
    : '/favicon.png';

export const APP_NAME = isOlhDomain ? 'OLH' : 'TetherAll';
